import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Edit,
  Create,
  SimpleForm,
  EditButton,
  DateField,
  DeleteButton, ReferenceInput, AutocompleteInput, ReferenceField,
  SelectInput, Pagination
} from 'react-admin';
import DateFnsUtils from "@date-io/date-fns";
import { DateInput } from "react-admin-date-inputs2";
import format from "date-fns/format";

import { MuiPickersUtilsProvider } from '@material-ui/pickers';


const TransactionHistPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 250, 500, 1000]} {...props} />;

const nameLikeSearch = (n) => {
  if (n && n.length >= 2) {
    return {
      name__like: n,
    }
  }
}

const emailSearch = (n) => {
  if (n && n.length >= 2) {
    return {
      email__like: n,
    }
  }
}
const dateParser = (date) => format(new Date(date), 'yyyy-MM');

const transactionHistFilters = [
  <ReferenceInput label="Project" source="project_id" reference="Project" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
  <MuiPickersUtilsProvider utils={DateFnsUtils} label="Created At" source="created_at__like">
    <DateInput
      source="timestamp__like"
      type="date"
      label="Created At"
      openTo="year"
      parse={dateParser}
      options={{
        dateFormat: "yyyy-MM",
        views: ["year", "month"],
        disableFuture: true,
      }}
    />
  </MuiPickersUtilsProvider>,

  <ReferenceInput label="Company" source="company_id" reference="Company" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput label="Comp" source="name"/>
  </ReferenceInput>,
  <ReferenceInput label="Exclude updates for Company" source="company_id__neq" reference="Company" perPage={100} sort={{field: 'id', order: 'asc'}} filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput label="Comp" source="name"/>
  </ReferenceInput>,
  <TextInput source="description__name__like" label="Description matches" alwaysOn/>,
  <TextInput source="prev_value__like" label="Previous value" alwaysOn/>,
  <TextInput source="new_value__like" label="New value" alwaysOn/>,
  <SelectInput label={'Action'} source={'action'}
    choices={[{
      id: 'UPDATE',
      name: 'update'
    },{
      id: 'INSERT',
      name: 'insert'
    },{
      id: 'DELETE',
      name: 'delete'
    }]} alwaysOn/>
];

//  transaction_id: Int!
//   user_id: Int
//   record_id: Int!
//   record_value_id: Int
//   fk_description_id: Int
//   timestamp: Date!
//   action: String!
//   prev_value: String
//   new_value: String
//   app: String
//   device_id: String
//   is_hide: Int


export const RecordsHistoryListView = props => (
  <List {...props} filters={transactionHistFilters} bulkActionButtons={[]} pagination={<TransactionHistPagination/>} >
    <Datagrid rowClick={null}>
      <TextField source="id" />
      <ReferenceField reference="User" source="user_id" link="show" label='User'>
        <TextField source="username" />
      </ReferenceField>
      <ReferenceField reference="Record" source="record_id" link="show" label='Record'>
        <TextField source="record_id" />
      </ReferenceField>
      <TextField source="record_value_id" />
      <ReferenceField reference="Description" source="fk_description_id" link="show" label='Description'>
        <TextField source="name" />
      </ReferenceField>
      <DateField source="timestamp" showTime />
      <TextField source="action" />
      <TextField source="prev_value" />
      <TextField source="new_value" />
      <TextField source="app" />
      <TextField source="is_hide" />
    </Datagrid>
  </List>
);

export const TranslationEdit = props => (
  <Edit title='Edit Translation' {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="english" />
      <TextInput source="zh" />
      <TextInput source="fr" />
      <TextInput source="es" />
      <TextInput source="de" />
      <TextInput source="th" />
    </SimpleForm>
  </Edit>
);

export const TranslationCreate = props => (
  <Create title='Create Translation' {...props}>
    <SimpleForm>
      <TextInput source="english" />
      <TextInput source="zh" />
      <TextInput source="fr" />
      <TextInput source="es" />
      <TextInput source="de" />
      <TextInput source="th" />
    </SimpleForm>
  </Create>
);
